import { ReactNode } from 'react';
import styles from "./Popup.module.css";
import commonStyles from "components/commonStyle/commonStyle.module.css";

interface PopupProps {
    title: string;
    children: ReactNode;
    submitLabel: string;
    closeLabel: string;
    isWithButton: boolean;
    isOpen: boolean;
    onClose: () => void;
    onSubmit?: () => void;
}

export default function Popup({
    title,
    children,
    submitLabel,
    closeLabel,
    isWithButton,
    isOpen,
    onClose,
    onSubmit,
}: PopupProps) {
    if (!isOpen) return null;
    return (

        <div className={styles.popupOverlay}>
            <div className={styles.popupContent}>
                <div className={styles.popupheader}>
                    <h2>{title}</h2>
                    <button className={styles.closeButton} onClick={onClose}>
                        &times;
                    </button>
                </div>
                <div className={styles.popupChildren} >
                    {children}

                    {isWithButton &&
                        <div className={styles.popupButtonContainer}>
                            <button type="button" className={styles.backButton} onClick={onClose}>{closeLabel}</button>
                            <button
                                type="button"
                                className={`${commonStyles.commonButton} ${styles.submitButton}`}
                                onClick={onSubmit} >
                                {submitLabel}
                            </button>
                        </div>}
                </div>
            </div>
        </div>
    );
}
